import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import SiteLayout from "../components/feature/SiteLayout";
import Home from "../pages/home/page";
import FiguresPage from "../pages/figures/page";
import TopicsPage from "../pages/topics/page";
import TopicDetailPage from "../pages/topics/detail/page";
import AboutPage from "../pages/about/page";

const routes: RouteObject[] = [
  {
    element: <SiteLayout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/figures",
        element: <FiguresPage />,
      },
      {
        path: "/topics",
        element: <TopicsPage />,
      },
      {
        path: "/topics/:slug",
        element: <TopicDetailPage />,
      },
      {
        path: "/about",
        element: <AboutPage />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;